import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';
import { formSubmit } from '../../../../datafetchers/IVFPage';
import { getCountryOnBasisOfUrl } from '../../../../Utils/ForeignUtils';
import AppointmentButton from './AppointmentButton';
import { FormTitle, ImmediateAssist, InputForm } from './styled';
import { getWebUserType } from '../../../../Utils/getWebUserType';
import { fireEvent } from '../../../../Utils/fireEvent';

export default function AppointmentForm(props) {
  const router = useRouter();
  const {
    heading,
    background,
    showFullForm,
    inputActive,
    desktopform,
    selectedCity,
  } = props;
  const [showLoader, setShowLoader] = useState(false);
  const setQuestionData = () => {
    if (showFullForm) {
      return [
        {
          question_text: 'Please tell us your full name?',
          question_id: 15,
          type: '1',
          answer_text: '',
        },
        {
          question_text: 'Your mobile number',
          question_id: 16,
          type: '1',
          answer_text: '',
        },
        {
          question_text: 'Your email ID',
          question_id: 17,
          type: '1',
          answer_text: '',
        },
        {
          question_text: 'Please tell us your current City',
          question_id: 18,
          type: '1',
          answer_text: '',
        },
      ];
    } else {
      return [
        {
          question_text: 'Please tell us your full name?',
          question_id: 88,
          type: '1',
          answer_text: '',
        },
        {
          question_text: 'Your mobile number',
          question_id: 89,
          type: '1',
          answer_text: '',
        },
        // {
        //     question_text: "Your email ID",
        //     question_id: 17,
        //     type: "1",
        //     answer_text: "",
        // },
        {
          question_text: 'Please tell us your current City',
          question_id: 90,
          type: '1',
          answer_text: '',
        },
      ];
    }
  };
  const data = {
    form: {
      id: desktopform ? 28 : 4,
      name: 'IVF Leads New',
    },
    questions: setQuestionData(),
  };

  const eventHandling = (value, question) => {
    fireEvent({
      category: 'entered_data',
      screen_name: 'ivf_static_next',
      user_type: getWebUserType(),
      id: 379,
      sku_type: 'lead',
      name: question,
      support_variable: value,
      page_url: typeof window != 'undefined' ? window.location.href : 'NA',
    });
  };
  const name = useRef('');
  const phoneNumber = useRef('');
  const email = useRef('');
  // const city = useRef("");
  const [city, setCity] = useState(
    selectedCity != 'Select City' && selectedCity ? selectedCity : '',
  );
  const country_code = getCountryOnBasisOfUrl();
  useEffect(() => {
    if (selectedCity != 'Select City') {
      setCity(selectedCity);
    } else {
      setCity('');
    }
  }, [selectedCity]);

  const onChangeName = (event) => {
    name.current = event.currentTarget.value;
  };
  const onChangeContact = (event) => {
    phoneNumber.current = event.currentTarget.value;
  };
  const onChangeEmail = (event) => {
    email.current = event.currentTarget.value;
  };
  const onChangeCity = (event) => {
    setCity(event.currentTarget.value);
    // city.current = event.currentTarget.value;
  };
  useEffect(() => {
    if (inputActive) {
      document.getElementById('name').focus();
    }
  }, [inputActive]);

  function getFormResponse() {
    data.questions.forEach((element) => {
      if (element.question_id == 15 || element.question_id == 88) {
        element.answer_text = name.current;
      } else if (element.question_id == 16 || element.question_id == 89) {
        element.answer_text = phoneNumber.current;
      } else if (element.question_id == 17) {
        element.answer_text = email.current;
      } else if (element.question_id == 18 || element.question_id == 90) {
        element.answer_text = city;
      }
    });
    return data.questions;
  }

  const SubmitHandler = async (event) => {
    event?.preventDefault();
    eventHandler();
    if (
      desktopform
        ? (name.current && phoneNumber.current && city) != ''
        : (name.current && phoneNumber.current && email.current && city) != ''
    ) {
      let payload = {
        form_id: data?.form.id,
        sku_id: 379,
        sku_name: 'Get Free Consultation on IVF',
        form_response: getFormResponse(),
      };
      setShowLoader(true);
      const ApiResponse = await formSubmit(payload, '', country_code);
      if (ApiResponse?.success) {
        setShowLoader(false);
        router.push(`/success`);
      } else {
        setShowLoader(false);
        alert('Something went wrong.');
      }
    } else if (name.current == '') {
      document.getElementById('name').focus();
      showNameError(true);
      showContactError(false);
      showEmailError(false);
      showCityError(false);
    } else if (phoneNumber.current == '') {
      document.getElementById('contact').focus();
      showContactError(true);
      showEmailError(false);
      showCityError(false);
      showNameError(false);
    } else if (email.current == '' && !desktopform) {
      document.getElementById('email').focus();
      showEmailError(true);
      showNameError(false);
      showCityError(false);
      showContactError(false);
    } else if (city == '') {
      document.getElementById('city').focus();
      showCityError(true);
      showNameError(false);
      showContactError(false);
      showEmailError(false);
    }
  };
  const eventHandler = () => {
    fireEvent({
      category: 'clicked_book_cta',
      screen_name: 'ivf_static_next',
      user_type: getWebUserType(),
      id: 379,
      sku_type: 'lead',
      cta: 'Book Appointment',
      name: 'Get Free Consultation on IVF',
      page_url: typeof window != 'undefined' ? window.location.href : 'NA',
      is_valid:
        (name.current &&
          phoneNumber.current &&
          email.current &&
          city &&
          !desktopform) != '' ||
        (name.current && phoneNumber.current && city && desktopform) != ''
          ? 1
          : 0,
    });
  };
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        SubmitHandler(e);
      }}
    >
      <InputForm background={background} desktopform={desktopform}>
        <div>
          {heading ? <FormTitle>{heading}</FormTitle> : null}
          <input
            type="text"
            placeholder="Enter Full name* "
            id="name"
            onChange={onChangeName}
            onBlur={() =>
              eventHandling(name.current, 'Please tell us your full name')
            }
            required={true}
          />
          <input
            type="tel"
            placeholder="Enter Phone number* "
            id="contact"
            onChange={onChangeContact}
            onBlur={() =>
              eventHandling(phoneNumber.current, 'Your mobile number')
            }
            pattern="[1-9]{1}[0-9]{9}"
            maxLength="10"
            required={true}
          />
          {showFullForm ? (
            <input
              type="email"
              placeholder="Enter Email id* "
              id="email"
              onChange={onChangeEmail}
              onBlur={() => eventHandling(email.current, 'Your email ID')}
              required={desktopform ? false : true}
            />
          ) : null}
          <input
            type="text"
            placeholder="Enter City* "
            id="city"
            onChange={onChangeCity}
            onBlur={() =>
              eventHandling(city, 'Please tell us your current City')
            }
            required={true}
            value={city}
          />
        </div>

        <AppointmentButton desktopform={desktopform} showLoader={showLoader} />
        <ImmediateAssist padd="3px 0 0">
          You will receive the details on whatsapp once you book your
          appointment
        </ImmediateAssist>
      </InputForm>
    </form>
  );
}
